/*!
 * TMG Specialist Vans — Custom Shopify Theme
 * Designed & developed by Shahir Islam
 * shahirislam7@gmail.com
 * © 2026 Shahir Islam. All rights reserved.
 * ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMegaMenu();
  initMobileNav();
  initCartDrawer();
  initSearchOverlay();
  initProductPage();
  refreshCartCount();
});

/* ============================================================
   HEADER — scroll state
   ============================================================ */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  }, { passive: true });
}

/* ============================================================
   MEGA MENU
   ============================================================ */
function initMegaMenu() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  document.querySelectorAll('.nav-btn[data-mega]').forEach(btn => {
    const target = btn.dataset.mega;
    const panel = document.querySelector(`.mega-menu[data-mega="${target}"]`);
    if (!panel) return;

    btn.addEventListener('mouseenter', () => openMega(btn, panel));
    btn.addEventListener('click', () => {
      if (panel.classList.contains('is-open')) closeMega(btn, panel);
      else openMega(btn, panel);
    });

    panel.addEventListener('mouseleave', () => closeMega(btn, panel));
  });

  document.addEventListener('mousedown', (e) => {
    if (!header.contains(e.target)) closeAllMega();
  });
}

function openMega(btn, panel) {
  closeAllMega();
  btn.classList.add('is-active');
  panel.classList.add('is-open');
}

function closeMega(btn, panel) {
  btn.classList.remove('is-active');
  panel.classList.remove('is-open');
}

function closeAllMega() {
  document.querySelectorAll('.nav-btn.is-active').forEach(b => b.classList.remove('is-active'));
  document.querySelectorAll('.mega-menu.is-open').forEach(p => p.classList.remove('is-open'));
}

/* ============================================================
   MOBILE NAV
   ============================================================ */
function initMobileNav() {
  const overlay  = document.querySelector('.mobile-nav-overlay');
  const nav      = document.querySelector('.mobile-nav');
  const openBtns = document.querySelectorAll('[data-mobile-nav-open]');
  const closeBtn = document.querySelector('[data-mobile-nav-close]');

  if (!nav) return;

  function open() {
    overlay.classList.add('is-open');
    nav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('is-open');
    nav.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(b => b.addEventListener('click', open));
  closeBtn && closeBtn.addEventListener('click', close);
  overlay && overlay.addEventListener('click', close);

  // Accordion
  document.querySelectorAll('.mobile-accordion__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      const isOpen = btn.classList.contains('is-open');
      // close all
      document.querySelectorAll('.mobile-accordion__btn.is-open').forEach(b => {
        b.classList.remove('is-open');
        b.nextElementSibling.classList.remove('is-open');
      });
      if (!isOpen) {
        btn.classList.add('is-open');
        body.classList.add('is-open');
      }
    });
  });

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
}

/* ============================================================
   CART DRAWER
   ============================================================ */
let cartIsOpen = false;

function initCartDrawer() {
  const overlay = document.querySelector('.cart-drawer-overlay');
  const drawer  = document.querySelector('.cart-drawer');
  if (!drawer) return;

  document.querySelectorAll('[data-cart-open]').forEach(btn => {
    btn.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-cart-close]').forEach(btn => {
    btn.addEventListener('click', closeCart);
  });
  overlay && overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartIsOpen) closeCart();
  });
}

function openCart() {
  const overlay = document.querySelector('.cart-drawer-overlay');
  const drawer  = document.querySelector('.cart-drawer');
  if (!drawer) return;
  cartIsOpen = true;
  overlay.classList.add('is-open');
  drawer.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  renderCartDrawer();
}

function closeCart() {
  const overlay = document.querySelector('.cart-drawer-overlay');
  const drawer  = document.querySelector('.cart-drawer');
  cartIsOpen = false;
  overlay && overlay.classList.remove('is-open');
  drawer && drawer.classList.remove('is-open');
  document.body.style.overflow = '';
}

async function renderCartDrawer() {
  const itemsEl = document.querySelector('.cart-drawer__items');
  const footerEl = document.querySelector('.cart-drawer__footer');
  if (!itemsEl) return;

  try {
    const cart = await fetchCart();
    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-empty">
          <svg class="cart-empty__icon" width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" stroke-width="1"/>
            <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="1"/>
            <path d="M16 10a4 4 0 01-8 0" stroke="currentColor" stroke-width="1"/>
          </svg>
          <p class="cart-empty__text">Your cart is empty</p>
          <button class="cart-empty__continue" onclick="closeCart()">Continue Shopping</button>
        </div>`;
      footerEl && (footerEl.style.display = 'none');
      return;
    }

    footerEl && (footerEl.style.display = '');

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">
          ${item.image
            ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
            : ''}
        </div>
        <div class="cart-item__details">
          <a href="/products/${item.handle}" class="cart-item__title" onclick="closeCart()">${escapeHtml(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>` : ''}
          <p class="cart-item__price">${formatMoney(item.line_price)}</p>
          <div class="cart-item__controls">
            <div class="qty-control">
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
            </div>
            <button class="cart-item__remove" onclick="changeQty('${item.key}', 0)">Remove</button>
          </div>
        </div>
      </div>`).join('');

    const subtotalEl = document.querySelector('.cart-drawer__subtotal-value');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  } catch (err) {
    console.error('Cart render error:', err);
  }
}

async function addToCart(variantId, quantity = 1) {
  const btn = document.querySelector('.product-form__add-btn');
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = '<span class="loading-spinner"></span>';
  }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await refreshCartCount();
    openCart();
  } catch (err) {
    console.error('Add to cart error:', err);
    alert('Could not add to cart. Please try again.');
  } finally {
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = 'Add to Cart';
    }
  }
}

async function changeQty(lineKey, newQty) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    });
    await refreshCartCount();
    renderCartDrawer();
  } catch (err) {
    console.error('Cart update error:', err);
  }
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function refreshCartCount() {
  try {
    const cart = await fetchCart();
    const badges = document.querySelectorAll('.cart-badge');
    badges.forEach(badge => {
      const count = cart.item_count;
      badge.textContent = count > 9 ? '9+' : count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(el => { el.textContent = cart.item_count; });
  } catch (err) {
    console.error('Cart count error:', err);
  }
}

function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

/* ============================================================
   SEARCH OVERLAY
   ============================================================ */
let searchTimeout;

function initSearchOverlay() {
  const overlay  = document.querySelector('.search-overlay');
  const input    = document.querySelector('.search-overlay__input');
  const closeBtn = document.querySelector('.search-overlay__close');
  if (!overlay) return;

  document.querySelectorAll('[data-search-open]').forEach(btn => {
    btn.addEventListener('click', openSearch);
  });
  closeBtn && closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeSearch();
  });

  if (input) {
    input.addEventListener('input', () => {
      clearTimeout(searchTimeout);
      const q = input.value.trim();
      if (q.length < 2) {
        renderSearchHint(q);
        return;
      }
      searchTimeout = setTimeout(() => doSearch(q), 250);
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });
}

function openSearch() {
  const overlay = document.querySelector('.search-overlay');
  const input   = document.querySelector('.search-overlay__input');
  overlay && overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => input && input.focus(), 100);
}

function closeSearch() {
  const overlay = document.querySelector('.search-overlay');
  const input   = document.querySelector('.search-overlay__input');
  overlay && overlay.classList.remove('is-open');
  document.body.style.overflow = '';
  if (input) {
    input.value = '';
    renderSearchHint('');
  }
}

async function doSearch(query) {
  const resultsEl = document.querySelector('.search-results');
  if (!resultsEl) return;
  try {
    const res = await fetch(
      `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`
    );
    const data = await res.json();
    const products = data.resources?.results?.products || [];

    if (products.length === 0) {
      resultsEl.innerHTML = `<p class="search-hint">No products found for &ldquo;${escapeHtml(query)}&rdquo;</p>`;
      return;
    }

    resultsEl.innerHTML = products.map(p => `
      <a href="${p.url}" class="search-result" onclick="closeSearch()">
        <div class="search-result__img">
          ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
        </div>
        <div class="search-result__info">
          <p class="search-result__title">${escapeHtml(p.title)}</p>
          <p class="search-result__price">${formatMoney(p.price)}${p.available === false ? ' · Sold Out' : ''}</p>
        </div>
        <svg class="search-result__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </a>`).join('');
  } catch (err) {
    console.error('Search error:', err);
  }
}

function renderSearchHint(query) {
  const resultsEl = document.querySelector('.search-results');
  if (!resultsEl) return;
  resultsEl.innerHTML = query.length === 0
    ? '<p class="search-hint">Start typing to search</p>'
    : '';
}

/* ============================================================
   PRODUCT PAGE
   ============================================================ */
function initProductPage() {
  initGallery();
  initVariantSelector();
  initAddToCart();
}

function initGallery() {
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.src;
      const alt = thumb.dataset.alt;
      if (src) { mainImg.src = src; mainImg.alt = alt || ''; }
    });
  });
}

function initVariantSelector() {
  const variantSelect = document.querySelector('.product-form__select[name="id"]');
  if (!variantSelect) return;

  variantSelect.addEventListener('change', () => {
    const selected = variantSelect.options[variantSelect.selectedIndex];
    const priceEl = document.querySelector('.product-price');
    const compareEl = document.querySelector('.product-compare-price');
    const addBtn = document.querySelector('.product-form__add-btn');

    if (selected.dataset.price && priceEl) {
      priceEl.textContent = formatMoney(parseInt(selected.dataset.price, 10));
    }
    if (compareEl) {
      if (selected.dataset.comparePrice && parseInt(selected.dataset.comparePrice) > parseInt(selected.dataset.price)) {
        compareEl.textContent = formatMoney(parseInt(selected.dataset.comparePrice, 10));
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      const available = selected.dataset.available !== 'false';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  });
}

function initAddToCart() {
  const form = document.querySelector('.product-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const variantSelect = form.querySelector('[name="id"]');
    const variantId = variantSelect ? variantSelect.value : form.dataset.variantId;
    if (variantId) addToCart(parseInt(variantId, 10));
  });
}

/* ============================================================
   NEWSLETTER FORM
   ============================================================ */
document.querySelectorAll('.newsletter-form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const emailInput = form.querySelector('input[type="email"]');
    const btn = form.querySelector('.newsletter-btn');
    if (!emailInput || !emailInput.value) return;
    if (btn) { btn.textContent = 'Done ✓'; btn.disabled = true; }
    setTimeout(() => {
      if (btn) { btn.textContent = 'Subscribe'; btn.disabled = false; }
      emailInput.value = '';
    }, 3000);
  });
});

/* expose for inline onclick usage */
window.closeCart    = closeCart;
window.changeQty    = changeQty;
window.closeSearch  = closeSearch;
